import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export type RChipVariant = 'ok' | 'no' | 'warn' | 'info' | 'neutral';

/**
 * Chip de readiness (rediseño Tech Premium): pastilla chica con ícono Lucide + label.
 * Reemplaza los <span className="badge" style={{…}}>… a mano de los boards/working views.
 * Colores por variante en styles.css (.rchip.*), calibrados para dark y claro.
 */
export function RChip({
  variant = 'neutral',
  icon: Icon,
  title,
  onClick,
  children,
}: {
  variant?: RChipVariant;
  icon?: LucideIcon;
  title?: string;
  onClick?: () => void;
  children: ReactNode;
}) {
  return (
    <span
      className={`rchip${variant !== 'neutral' ? ` ${variant}` : ''}`}
      title={title}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      {Icon && <Icon size={11} strokeWidth={2} />}
      {children}
    </span>
  );
}
